/**
 *
 * Subscribe
 *
 */

import React, { useCallback } from 'react';
import styled from 'styled-components';
import { useLocation, useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, FormGroup, Checkbox, HelpBlock, Button } from 'react-bootstrap';
import { useCurrentUser } from 'containers/User';
import useLocale from 'containers/SettingsProvider/useLocale';
import withRoute from 'containers/withRoute';
import messages from './messages';
import useCheckout from './useCheckout';
import LoginAlert from '../LoginAlert';

const ERROR_MESSAGES = {
  unauthorized: messages.signInError,
  failed: messages.checkoutError,
};

const Help = styled(HelpBlock)`
  &.help-block {
    font-size: small;
    margin-left: 2rem;
    margin-top: -1rem;
    .btn {
      font-size: small;
    }
  }
`;

function Subscribe() {
  const user = useCurrentUser();
  const language = useLocale();
  const { pathname, search, hash } = useLocation();
  const history = useHistory();
  const [status, checkout] = useCheckout();
  const showConditions = useCallback(
    () => {
      const state = `${pathname}${search}${hash}`;
      history.push('#conditions', state);
    },
    [pathname, search, hash, history],
  );
  if (!user.api) {
    return <LoginAlert />;
  }

  function handleSubmit(ev) {
    ev.preventDefault();
    const recurring = ev.target.elements.recurring.checked;
    checkout({ user, language, recurring });
  }
  const busy = status === 'busy';
  const errorMessage = ERROR_MESSAGES[status];
  const submitText = user.pm ? messages.extend : messages.header;
  const subscriptionMessage = {
    ...messages.premiumUntilDate,
    values: { date: user.premiumDate },
  };
  return (
    <form onSubmit={handleSubmit}>
      {user.pm && (
        <p>
          <FormattedMessage {...subscriptionMessage} />
        </p>
      )}
      <FormGroup>
        <Checkbox name="recurring" value="true">
          <FormattedMessage {...messages.recurringLabel} />
        </Checkbox>
        <Help>
          <FormattedMessage {...messages.recurringHelp} />
        </Help>
      </FormGroup>
      <FormGroup>
        <Checkbox name="acceptConditions" required>
          <FormattedMessage {...messages.acceptConditions} />
        </Checkbox>
        <Help>
          <Button bsStyle="link" className="p-0" onClick={showConditions}>
            <FormattedMessage {...messages.viewConditions} />
          </Button>
        </Help>
      </FormGroup>
      {errorMessage && (
        <Alert bsStyle="danger">
          <FormattedMessage {...errorMessage} />
        </Alert>
      )}
      <div className="text-center">
        <Button bsStyle="success" type="submit" disabled={busy}>
          {busy && <FontAwesomeIcon icon="spinner" spin className="mr-2" />}
          <FormattedMessage {...submitText} />
        </Button>
      </div>
    </form>
  );
}

export default withRoute(Subscribe);
